import symbol from "./symbol.js";
import symbolDS4 from "./symbol[ds-4].js";
<ebay-icon ...input _name="program-badge-authenticity-guaranteed" _type="program-badge" _themes=[symbol, symbolDS4]/>
